import { render, staticRenderFns } from "./MarketCreateEdit.vue?vue&type=template&id=8c5d5024"
import script from "./MarketCreateEdit.vue?vue&type=script&lang=js"
export * from "./MarketCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports